import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J5M2 (Sample Receipt Reversal)
// ============================================================

export interface WriteoffItem {
  fj120_01: string;         // Receipt no (PK)
  fj120_11: string;         // Receipt date (formatted string)
  fj120_12: string;         // Warehouse name (lookup from F105)
  fj120_14: string;         // Department name (lookup from F106)
  fj120_15: number;         // Receipt amount
  fj120_10: string;         // Location code
  wh_code: string;          // Warehouse code (original)
  dept_code: string;        // Department code (original)
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j5m2Api = {
  /** Query sample receipt items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/j5m2/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected items */
  async execute(receiptNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j5m2/execute', {
      receipt_nos: receiptNos,
      confirmed: true,
    });
    return res.data;
  },
};
